import { gql } from '@apollo/client';

export const ADD_COURSE_LEARNING_OBJECT = gql`
    mutation addCourseLearningObject( $courseID: UUID!, $learningObjectID: UUID! ) {
        result: addCourseLearningObject( courseID: $courseID, learningObjectID: $learningObjectID ) {
            success message
        }
    }
`;

export const DELETE_COURSE_LEARNING_OBJECT = gql`
    mutation deleteCourseLearningObject( $courseID: UUID!, $learningObjectID: UUID! ) {
        result: deleteCourseLearningObject( courseID: $courseID, learningObjectID: $learningObjectID ) {
            success message
        }
    }
`;

export const ENABLE_COURSE_LEARNING_OBJECT = gql`
    mutation enableCourseLearningObject( $courseID: UUID!, $learningObjectID: UUID! ) {
        result: enableCourseLearningObject( courseID: $courseID, learningObjectID: $learningObjectID ) {
            success message
        }
    }
`;

export const DISABLE_COURSE_LEARNING_OBJECT = gql`
    mutation disableCourseLearningObject( $courseID: UUID!, $learningObjectID: UUID! ) {
        result: disableCourseLearningObject( courseID: $courseID, learningObjectID: $learningObjectID ) {
            success message
        }
    }
`;

export const SORT_COURSE_LEARNING_OBJECTS = gql`
    mutation sortCourseLearningObjects( $input: SortCourseLearningObjectsInput! ) {
        result: sortCourseLearningObjects( input: $input ) {
            success message
        }
    }
`;
